import { useState, useEffect } from 'react';

export const useIsMobile = (mobileWidthInPx = 640) => {
	const [width, setWidth] = useState(window.innerWidth);

	const handleWindowSizeChange = () => {
		setWidth(window.innerWidth);
	};

	useEffect(() => {
		window.addEventListener('resize', handleWindowSizeChange);
		return () => {
			window.removeEventListener('resize', handleWindowSizeChange);
		};
	}, []);

	const isMobile = width <= mobileWidthInPx;
	return isMobile;
};
